export function initGallery() {
    const gallerys = [...document.querySelectorAll('div.galleryblock')]
    if (!gallerys || gallerys.count == 0) return

    for (let i = 0; i < gallerys.length; i++) {
        const gallery = gallerys[i]
        const leftStepper = gallery.querySelector('div.stepper.left')
        const rightStepper = gallery.querySelector('div.stepper.right')
        const dots = [...gallery.querySelectorAll('div.page-control .dot')]

        if (leftStepper && rightStepper) {
            leftStepper.addEventListener('click', handleLeftClick)
            rightStepper.addEventListener('click', handleRightClick)

            for (let i = 0; i < dots.length; i++) {
                dots[i].addEventListener('click', handleDotClick)
            }
        }
    }
}

const handleLeftClick = (e) => {
    const stepper = e.target
    const wrapper = stepper.parentElement.parentElement
    move(wrapper, false)
}

const handleRightClick = (e) => {
    const stepper = e.target
    const wrapper = stepper.parentElement.parentElement
    move(wrapper, true)
}

const handleDotClick = (e) => {
    const dot = e.target
    const dots = dot.parentElement
    const wrapper = dots.parentElement.parentElement

    const dIndex = Number(dot.dataset.index)
    const wIndex = Number(wrapper.dataset.index)
    const isNegative = wIndex + 1 > dIndex
    const between = isNegative ? range(dIndex, wIndex) : range(wIndex + 1, dIndex)

    for (let i = 0; i < between.length; i++) {
        setTimeout(() => move(wrapper, !isNegative), 0 + (i * 150))
    }
}

const move = (wrapper, forwards) => {
    const topBar = wrapper.querySelector('div.horizontal-bar.top')
    const images = [...wrapper.querySelectorAll('div.images .image')]
    const index = Number(wrapper.dataset.index)
    const json = JSON.parse(topBar.dataset.titleJson)

    if (forwards && (index + 1) > (images.length - 1)) return
    else if (!forwards && index == 0) return
    
    const targetIndex = forwards ? index + 1 : index
    const wrapperIndex = forwards ? index + 1 : index - 1

    const targetImage = wrapper.querySelector(`div.image[data-index='${targetIndex}']`)
    const targetDot = wrapper.querySelector(`div.page-control .dot[data-index='${wrapperIndex}']`)
    const activeDot = wrapper.querySelector('div.page-control .dot.active')

    activeDot.classList.remove('active')
    targetDot.classList.add('active')

    wrapper.dataset.index = wrapperIndex
    forwards ? targetImage.classList.add('visible') : targetImage.classList.remove('visible')

    const p = topBar.querySelector('p')
    p.innerHTML = json[wrapperIndex]

    if (!forwards) {
        targetImage.classList.add('invisible')
        setTimeout(() => targetImage.classList.remove('invisible'), 1500)
    }
}

// https://stackoverflow.com/questions/8069315#answer-33457557
function range(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
}
